module.exports = __webpack_public_path__ + "fonts/nucleo-icons.f82ec6ba.ttf";